(function(){
  var C = window.__PaisagenVIPCore;
  if (!C) { console.error('Paisagen VIP core missing'); return; }
  var subscribe = C.subscribe, getState = C.getState, fetchCart = C.fetchCart, turnOn = C.turnOn, turnOff = C.turnOff, convertAndFormat = C.convertAndFormat, fmtDecimal = C.fmtDecimal, escapeHtml = C.escapeHtml, isoToFlagEmoji = C.isoToFlagEmoji;
  var MEMBERSHIP_USD = C.MEMBERSHIP_USD, FREE_SHIP_THRESHOLD_USD = C.FREE_SHIP_THRESHOLD_USD, NECKLACE_USD = C.NECKLACE_USD;

  function initCart(){
    var root = document.getElementById('paisagen-cart');
    if (!root || root.dataset.paisagenInit) return;
    root.dataset.paisagenInit = 'true';

    var cartUrl = root.getAttribute('data-cart-url') || '/cart';
    var isRealVip = root.getAttribute('data-is-vip') === 'true';
    var countryIso = root.getAttribute('data-country-iso') || 'US';
    var countryName = root.getAttribute('data-country-name') || 'the US';
    var flagEmoji = isoToFlagEmoji ? isoToFlagEmoji(countryIso) : '🌍';
    var vipEl = document.getElementById('paisagen-cart-vip');
    var toggle = document.getElementById('paisagen-vip-toggle');
    var headline = document.getElementById('paisagen-vip-headline');
    var sub = document.getElementById('paisagen-vip-sub');
    var shipBanner = root.querySelector('.paisagen-cart__ship-banner');
    var closeNudge = document.getElementById('paisagenCloseNudge');
    var nudgeTurnOn = document.getElementById('paisagenNudgeTurnOn');
    var nudgeDismiss = document.getElementById('paisagenNudgeDismiss');
    var refreshingBody = false;
    var recsLoading = false;
    var isVipOn = false;
    var nudgeShownThisSession = false;

    function setBannerText(text){
      if (!shipBanner) return;
      shipBanner.innerHTML = '<span class="pg-flag" data-iso="' + countryIso + '">' + flagEmoji + '</span> ' + text;
    }

    // Real VIP members (tagged 'Active Subscriber') always get the gold
    // banner with no $ threshold copy, permanently — independent of
    // whether the membership line item happens to be in the cart. This is
    // enforced here (not just server-side) because render() below runs on
    // every cart fetch and would otherwise stomp the server-rendered
    // VIP banner with the non-member $150 copy.
    function enforceVipBanner(){
      if (!isRealVip || !shipBanner) return;
      setBannerText('Free Shipping to ' + countryName + ' — Always, As a VIP Member');
      shipBanner.classList.add('paisagen-cart__ship-banner--vip');
      var progressEl = document.getElementById('paisagen-cart-ship-progress');
      if (progressEl) progressEl.remove();
    }
    enforceVipBanner();

    var discEl = document.getElementById('paisagenDiscAmt');
    if (discEl) discEl.textContent = convertAndFormat(MEMBERSHIP_USD);

    function render(isOn){
      isVipOn = isOn;
      var necklaceF = convertAndFormat(NECKLACE_USD);
      if (vipEl) vipEl.classList.toggle('is-on', isOn);
      if (toggle) { toggle.classList.toggle('is-on', isOn); toggle.setAttribute('aria-checked', String(isOn)); }
      if (headline) headline.textContent = isOn ? '80% off is on' : 'Turn on 80% off';
      if (sub) sub.textContent = 'Free ' + necklaceF + ' Necklace + Free Shipping';
      if (isRealVip) {
        enforceVipBanner();
      } else if (shipBanner) {
        setBannerText(isOn
          ? 'Free Shipping to ' + countryName + ' On Every Order'
          : 'Free Shipping to ' + countryName + ' Over ' + convertAndFormat(FREE_SHIP_THRESHOLD_USD));
      }
    }
    subscribe(function(s){ if (s.cart) render(s.inCart); });

    function extractImg(p){
      var c = (p.images&&p.images.length)?p.images[0]:(p.image||p.featured_image);
      if (!c) return '';
      if (typeof c === 'string') return c;
      return c.src || c.url || '';
    }

    function loadRecs(){
      if (recsLoading) return Promise.resolve();
      var container = document.getElementById('paisagen-cart-recs');
      if (!container) return Promise.resolve();
      recsLoading = true;
      container.innerHTML = '<p class="paisagen-cart__recs-loading">Loading suggestions...</p>';
      return fetch('/cart.js').then(function(r){ return r.json(); }).then(function(cart){
        var currency = cart.currency;
        var excludeIds = cart.items.map(function(i){ return i.product_id; });
        var lastItem = cart.items.length ? cart.items[cart.items.length-1] : null;
        var lastProductId = lastItem ? lastItem.product_id : null;
        var relatedP = lastProductId
          ? fetch('/recommendations/products.json?product_id='+lastProductId+'&limit=8&intent=related').then(function(r){return r.json();}).then(function(d){ return (d.products||[]).map(function(p){ return norm(p,true); }); }).catch(function(){ return []; })
          : Promise.resolve([]);
        var genericP = fetch('/products.json?limit=20').then(function(r){return r.json();}).then(function(d){ return (d.products||[]).map(function(p){ return norm(p,false); }); }).catch(function(){ return []; });
        function norm(p, cents){
          var c = Object.assign({},p);
          c.variants = (p.variants||[]).map(function(v){
            var vc = Object.assign({},v);
            vc.price = cents ? (parseFloat(v.price)||0)/100 : (parseFloat(v.price)||0);
            if (v.compare_at_price) vc.compare_at_price = cents ? (parseFloat(v.compare_at_price)||0)/100 : (parseFloat(v.compare_at_price)||0);
            return vc;
          });
          if (p.price!==undefined) c.price = cents ? (parseFloat(p.price)||0)/100 : (parseFloat(p.price)||0);
          return c;
        }
        return Promise.all([relatedP, genericP]).then(function(res){
          var combined = res[0].concat(res[1]);
          var seen = {}, filtered = [];
          combined.forEach(function(p){
            if (excludeIds.indexOf(p.id)!==-1) return;
            if (seen[p.id]) return;
            seen[p.id] = true;
            filtered.push(p);
          });
          renderRecs(filtered.slice(0,4), currency);
        });
      }).catch(function(){ container.innerHTML=''; }).finally(function(){ recsLoading=false; });
    }

    function renderRecs(products, currency){
      var container = document.getElementById('paisagen-cart-recs');
      if (!container) return;
      if (!products.length) { container.innerHTML=''; return; }
      var html = '<p class="paisagen-cart__recs-heading">Complete the Look</p><div class="paisagen-cart__recs-list">';
      products.forEach(function(p, idx){
        var img = extractImg(p);
        var variants = p.variants||[];
        var url = p.url || ('/products/'+p.handle);
        var first = variants[0]||{};
        var price = first.price!==undefined?first.price:p.price;
        html += '<div class="paisagen-cart__rec-item" data-product-id="'+p.id+'">';
        html += '<a href="'+url+'" class="paisagen-cart__rec-media">'+(img?'<img src="'+img+'" loading="lazy" alt="'+escapeHtml(p.title)+'">':'')+(idx===0?'<span class="paisagen-cart__rec-badge">Bestseller</span>':'')+'</a>';
        html += '<div><a href="'+url+'" class="paisagen-cart__rec-title">'+escapeHtml(p.title)+'</a><p class="paisagen-cart__rec-price">'+fmtDecimal(price,currency);
        if (first.compare_at_price && first.compare_at_price>price) html += '<span class="paisagen-cart__rec-compare">'+fmtDecimal(first.compare_at_price,currency)+'</span>';
        html += '</p></div>';
        html += '<button type="button" class="paisagen-cart__rec-btn" data-paisagen-rec-add data-variant-id="'+(first.id||'')+'">Add</button>';
        html += '</div>';
      });
      html += '</div>';
      container.innerHTML = html;
    }

    function refreshBodyOnly(){
      if (refreshingBody) return Promise.resolve();
      refreshingBody = true;
      return fetch(window.location.pathname + window.location.search)
        .then(function(res){ return res.text(); })
        .then(function(html){
          var doc = new DOMParser().parseFromString(html,'text/html');
          var newBody = doc.getElementById('paisagen-cart-body');
          var oldBody = document.getElementById('paisagen-cart-body');
          var newFooter = doc.getElementById('paisagen-cart-footer');
          var oldFooter = document.getElementById('paisagen-cart-footer');
          if (newBody && oldBody) oldBody.innerHTML = newBody.innerHTML;
          if (newFooter && oldFooter) oldFooter.innerHTML = newFooter.innerHTML;

          if (!isRealVip) {
            var newShip = doc.getElementById('paisagen-cart-ship-progress');
            var oldShip = document.getElementById('paisagen-cart-ship-progress');
            if (newShip) {
              if (oldShip) {
                oldShip.outerHTML = newShip.outerHTML;
              } else if (shipBanner) {
                shipBanner.insertAdjacentHTML('afterend', newShip.outerHTML);
              }
            } else if (oldShip) {
              oldShip.remove();
            }
          }
          var s = getState ? getState() : null;
          render(s && s.inCart);
        })
        .finally(function(){ refreshingBody = false; });
    }

    function openCart(){
      root.classList.add('is-open');
      document.body.classList.add('paisagen-cart-open');
      if (closeNudge) closeNudge.classList.remove('show');
      fetchCart(true);
      refreshBodyOnly().then(loadRecs);
    }
    function actuallyClose(){
      root.classList.remove('is-open');
      document.body.classList.remove('paisagen-cart-open');
      if (closeNudge) closeNudge.classList.remove('show');
      setTimeout(function(){
        document.body.style.removeProperty('overflow');
        document.documentElement.style.removeProperty('overflow');
      }, 300);
    }
    function closeCart(){
      var s = getState ? getState() : null;
      var hasItems = s && s.cart && s.cart.item_count > 0;
      if (!isRealVip && !isVipOn && hasItems && !nudgeShownThisSession && closeNudge) {
        nudgeShownThisSession = true;
        closeNudge.classList.add('show');
        return;
      }
      actuallyClose();
    }

    if (nudgeTurnOn) {
      nudgeTurnOn.addEventListener('click', function(){
        nudgeTurnOn.disabled = true;
        turnOn().then(function(){ actuallyClose(); }).catch(function(){ nudgeTurnOn.disabled = false; });
      });
    }
    if (nudgeDismiss) {
      nudgeDismiss.addEventListener('click', function(){ actuallyClose(); });
    }

    document.addEventListener('cart:refresh', function(){
      if (root.classList.contains('is-open')) { refreshBodyOnly().then(loadRecs); }
    });
    document.addEventListener('paisagen:vip:sync', function(){
      if (root.classList.contains('is-open')) { refreshBodyOnly().then(loadRecs); }
    });

    if (toggle) {
      toggle.addEventListener('click', function(){
        if (toggle.disabled) return;
        toggle.disabled = true;
        var goingOn = !toggle.classList.contains('is-on');
        var task = goingOn ? turnOn() : turnOff();
        task.then(function(){ toggle.disabled = false; refreshBodyOnly().then(loadRecs); }).catch(function(){ toggle.disabled = false; });
      });
    }

    document.addEventListener('change', function (e) {
      var sel = e.target.closest('[data-paisagen-variant-select]');
      if (!sel || !root.contains(sel)) return;
      var line = parseInt(sel.getAttribute('data-line'), 10);
      var qty = parseInt(sel.getAttribute('data-qty'), 10) || 1;
      var newVariantId = sel.value;
      sel.disabled = true;
      fetch('/cart/change.js', {method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({line: line, quantity: 0})})
        .then(function(){
          return fetch('/cart/add.js', {method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({items:[{id: newVariantId, quantity: qty}]})});
        })
        .then(function(){ fetchCart(true); refreshBodyOnly().then(loadRecs); })
        .catch(function(){ sel.disabled = false; });
    });

    document.addEventListener('click', function (e) {
      if (root.contains(e.target)) return;
      var trigger = e.target.closest('a[href$="/cart"], a[href*="/cart?"], [aria-label*="cart" i], [data-cart-icon], .cart-icon, #cart-icon-bubble');
      if (trigger) { e.preventDefault(); e.stopPropagation(); openCart(); }
    }, true);

    document.addEventListener('click', function (e) {
      if (!root.contains(e.target)) return;
      if (e.target.closest('.paisagen-cart__overlay') || e.target.closest('.paisagen-cart__close')) { closeCart(); return; }

      var qtyBtn = e.target.closest('[data-paisagen-qty]');
      if (qtyBtn) {
        var line = parseInt(qtyBtn.getAttribute('data-line'), 10);
        var action = qtyBtn.getAttribute('data-action');
        var valueEl = qtyBtn.parentElement.querySelector('[data-paisagen-qty-value]');
        var current = valueEl ? parseInt(valueEl.textContent, 10) : 1;
        var next = action === 'increase' ? current + 1 : current - 1;
        fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({line:line,quantity:Math.max(0,next)})})
          .then(function(){ fetchCart(true); refreshBodyOnly().then(loadRecs); });
        return;
      }
      var removeBtn = e.target.closest('[data-paisagen-remove]');
      if (removeBtn) {
        fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({line:parseInt(removeBtn.getAttribute('data-line'),10),quantity:0})})
          .then(function(){ fetchCart(true); refreshBodyOnly().then(loadRecs); });
        return;
      }
      var recAdd = e.target.closest('[data-paisagen-rec-add]');
      if (recAdd) {
        var vid = recAdd.getAttribute('data-variant-id');
        if (!vid) return;
        recAdd.disabled = true; recAdd.textContent = 'Adding...';
        fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:vid,quantity:1}]})})
          .then(function(){ fetchCart(true); refreshBodyOnly().then(loadRecs); })
          .catch(function(){ recAdd.disabled=false; recAdd.textContent='Add'; });
        return;
      }
      var checkoutBtn = e.target.closest('[data-paisagen-checkout]');
      if (checkoutBtn) { window.location.href = cartUrl + '/checkout'; return; }
    });

    document.addEventListener('keydown', function(e){ if (e.key === 'Escape') closeCart(); });

    window.paisagenOpenCart = openCart;
    window.paisagenCloseCart = closeCart;

    var lastItemCount = null;
    subscribe(function(s){
      if (!s.cart) return;
      if (lastItemCount !== null && s.cart.item_count > lastItemCount && !root.classList.contains('is-open')) {
        setTimeout(function(){ openCart(); }, 60);
      }
      lastItemCount = s.cart.item_count;
    });
  }

  window.PaisagenVIP = window.PaisagenVIP || {};
  Object.assign(window.PaisagenVIP, C, { initCart: initCart });
})();
